/*
 * @Author: Bai.Zhiming
 * @Date: 2019-6-27
 * @LastEditTime: 2020-07-27 11:11:42
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\left\iWoLeft.js
 * @Description:  采编中心iwo左侧导航
 */ 
angular.module('iWoLeftModule', [
    'personalDraftLeftModule', // 个人采写左侧导航
    'departmentLeftModule', // 部门稿库左侧导航
    'customLeftModule' // 常用订阅左侧导航
]).controller('iWoLeftCtrl', ['$scope',
    function($scope) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {

        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {}
    }
]);
